import { render, staticRenderFns } from "./ProfileBans.vue?vue&type=template&id=8015d0ee&scoped=true&"
import script from "./ProfileBans.vue?vue&type=script&lang=js&"
export * from "./ProfileBans.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBans.vue?vue&type=style&index=0&id=8015d0ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8015d0ee",
  null
  
)

export default component.exports